const courseTabsContainer = document.querySelector('.course--tabs');
const courseTabs = document.querySelectorAll('.course--tab');
const tabsContent = document.querySelectorAll('.course--map');
const detailTabsContainer = document.querySelectorAll('.detail--tabs');
const detailTabs = document.querySelectorAll('.detail--tab');
const detailContent = document.querySelectorAll('.detail--content');

class Tab {
  constructor() {
    this.mapTabClick();
    this.detailTabClick();
  }

  mapTabClick() {
    courseTabsContainer.addEventListener('click', function (e) {
      const clickedEl = e.target.closest('.course--tab');

      if (!clickedEl) return;

      // アクティブボタン
      courseTabs.forEach((tab) => tab.classList.remove('tab--active'));
      clickedEl.classList.add('tab--active');

      // アクティブコンテンツ
      tabsContent.forEach((content) =>
        content.classList.remove('content--active')
      );
      document
        .querySelector(`.course--map${clickedEl.dataset.tab}`)
        .classList.add('content--active');
    });
  }
  detailTabClick() {
    detailTabsContainer.forEach((container) =>
      container.addEventListener('click', function (e) {
        const clickedEl = e.target.closest('.detail--tab');
        console.log(clickedEl);
        console.log(clickedEl.dataset.detailTab);

        if (!clickedEl) return;

        // アクティブボタン
        detailTabs.forEach((tab) => tab.classList.remove('tab--active'));
        clickedEl.classList.add('tab--active');

        document
          .querySelector(`.followingTab${clickedEl.dataset.detailtab}`)
          .classList.add('tab--active');
        document
          .querySelector(`.normalTab${clickedEl.dataset.detailtab}`)
          .classList.add('tab--active');
      })
    );
  }
}
export default Tab;
